import Confirmation from '@CS/components/Popups/Confirmation';
import HomeIcon from '@CS/assets/Vector/home.svg?component';
import Button from '@CS/components/Button';
import { useState } from 'react';

export const CloseButton = () => {
  const confirm = location.pathname === '/editor';
  const closeConfirm = () => setVisibleConfirm(false);

  const [visibleConfirm, setVisibleConfirm] = useState(false);
  const onSubmit = () => (location.href = 'gmalite://gmalite-home');

  return (
    <>
      <Button
        onClick={(confirm && (() => setVisibleConfirm(true))) || void 0}
        link={(!confirm && 'gmalite://gmalite-home') || void 0}
        variant="iconFill"
        style={{
          left: 'min(6.4vmin, 24px)',
          top: 'min(12.8vmin, 48px)',
          position: 'fixed',
          display: 'block',
          zIndex: '2'
        }}
      >
        <HomeIcon />
      </Button>

      {visibleConfirm && (
        <Confirmation onSubmit={onSubmit} onCancel={closeConfirm} />
      )}
    </>
  );
};
